module.exports = __webpack_public_path__ + "static/img/4981_phase_function_Paper_Points.a155022.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4981_phase_function_Paper_Points.png
// module id = aRUx
// module chunks = 0